export const systemFolderType = {
  INSURED_VISIBLE: 1,
  INSURED_ONEDRIVE_FOLDER: 43,
  INSURED_GOOGLEDRIVE_FOLDER: 45,
  POLICY_FOLDER: 18,
  SENT_CERTIFICATES: 53,
};
